module.exports = __webpack_public_path__ + "static/media/get-started-image.fa373a37.svg";